import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../../hooks/useAuth";
import { canAccessReport, type ReportId } from "./reportAccess";

interface RequireReportAccessProps extends PropsWithChildren {
  reportId: ReportId;
}

function resolveFallbackPath(userType: "office" | "crew" | undefined) {
  if (!userType) {
    return "/login";
  }

  return "/dashboard";
}

export function RequireReportAccess({ reportId, children }: RequireReportAccessProps) {
  const { user } = useAuth();

  if (!canAccessReport(user, reportId)) {
    return <Navigate to={resolveFallbackPath(user?.type)} replace />;
  }

  return <>{children}</>;
}
